var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"main"}},[(_vm.isMobile)?[_c('transition',{attrs:{"name":"fade","mode":"out-in"},on:{"before-enter":_vm.onBeforeEnter,"leave":_vm.onLeave,"after-leave":_vm.onAfterLeave}},[_c('router-view')],1)]:[_c('DesktopPage')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }